const GLOBAL_HEADER_CLASS = "global-head";
const RIBBON_CLASS = "ribbon";
const BACKDROP_CLASS = "backdrop";
const NO_SCROLL_CLASS = "no-scroll";
export {
  BACKDROP_CLASS,
  GLOBAL_HEADER_CLASS,
  NO_SCROLL_CLASS,
  RIBBON_CLASS
};
//# sourceMappingURL=index.es.js.map
